import { render } from "./HomeDisplayBlock.vue?vue&type=template&id=ffcb3fd6&scoped=true"
import script from "./HomeDisplayBlock.vue?vue&type=script&lang=js"
export * from "./HomeDisplayBlock.vue?vue&type=script&lang=js"

import "./HomeDisplayBlock.vue?vue&type=style&index=0&id=ffcb3fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffcb3fd6"]])

export default __exports__